<template>
  <div class="MaintainLog">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div
          style="width:100vw"
        >
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">維修履歷</span>
              </b-col>
              <b-col cols="12" class="mx-0" style="margin-top: 1rem">
                <b-row>
                  <commonQueryIoT />
                </b-row>
              </b-col>
              <b-col cols="12" class="mx-0 text-right" style="margin-top: 1rem">
                <exportCsv />
              </b-col>
              <b-col cols="12" class="mx-0" style="margin-top: 1rem">
                <div
                  style="
                    width: 100%;
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                    padding: 7.2px;
                  "
                >
                  <span>梓官廠機台報修紀錄</span>
                </div>
                <b-table
                  sticky-header="240px"
                  :items="maintainStatusZiguan"
                  :fields="maintainLogFields"
                  :no-border-collapse="noCollapse"
                  responsive
                  class="maintain-status-table-detail"
                >
                </b-table>
              </b-col>
              <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                <div
                  style="
                    width: 100%;
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                    padding: 7.2px;
                  "
                >
                  <span>橋頭廠機台報修紀錄</span>
                </div>
                <b-table
                  sticky-header="240px"
                  :items="maintainStatusQiaotou"
                  :fields="maintainLogFields"
                  :no-border-collapse="noCollapse"
                  responsive
                  class="maintain-status-table-detail"
                >
                </b-table>
              </b-col>
            </b-col>
            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import $ from "jquery";
import exportCsv from "@/components/exportCsv.vue";
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MaintainLog",
  data() {
    return {
      maintainLogFields: [
        {
          key: "device",
          label: "機台",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "model",
          label: "型號",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "startTime",
          label: "報修開始時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "endTime",
          label: "報修結束時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "reason",
          label: "報修原因",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "accumulation",
          label: "維修總時長",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
      ],
      maintainStatusZiguan: [],
      maintainStatusQiaotou: [],
    };
  },
  created: function () {
    let vm = this;
    vm.getMaintainDataDefault();
    vm.setQueryInput();
  },
  mounted: function () {},
  components: {
    exportCsv,
    commonQueryIoT,
  },
  watch: {
    commonQueryResponse: {
      handler() {
        let vm = this;
        if (
          vm.commonQueryResponse == "查無資料" ||
          vm.commonQueryResponse == "時間尚未選擇"
        ) {
          return;
        }
        vm.maintainStatusZiguan = vm.commonQueryResponse.maintain_data_Ziguan;
        vm.maintainStatusQiaotou = vm.commonQueryResponse.maintain_data_Qiaotou;
        vm.setExportExcelData(vm.maintainLogFields, vm.commonQueryResponse);
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      commonQueryResponse: "commonqueryiot/get_queryResponse",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_exportExcelFileName: "exportcsv/set_exportExcelFileName",
      set_exportExcelData: "exportcsv/set_exportExcelData",
      show_loadScreenModal: "loadscreenmodal/show_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal",
    }),
    setQueryInput() {
      let vm = this;
      vm.set_phpfunction("Query_Maintain_Log");

      vm.set_selectTag({});
      vm.set_selectTagCheck({
        process: false,
        deviceCode: false,
      });
    },
    getMaintainDataDefault() {
      let vm = this;
      let params = {};
      let today = new Date();
      let endTime =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        today.getDate() +
        " 23:59:59";

      let previousTime = today.setDate(today.getDate() - 7);
      previousTime = new Date(previousTime);

      let startTime =
        previousTime.getFullYear() +
        "-" +
        (previousTime.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        previousTime.getDate() +
        " 00:00:00";
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["startTime"] = startTime;
      params["endTime"] = endTime;
      params["whichFunction"] = "Query_Maintain_Log";
      vm.show_loadScreenModal();
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        let result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.maintainStatusZiguan = result.QueryTableData.maintain_data_Ziguan;
          vm.maintainStatusQiaotou =
            result.QueryTableData.maintain_data_Qiaotou;
          vm.setExportExcelData(vm.maintainLogFields, result.QueryTableData);
        }
      });
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
    clearExportExcel() {
      let vm = this;
      vm.set_exportExcelData([]);
      vm.set_exportExcelFileName("");
    },
    setExportExcelData(title, data) {
      let vm = this;
      let fileName = "維修履歷" + data.query_time;
      let titleField = [];
      let titleKey = [];
      title.forEach((item) => {
        titleKey.push(item.key);
        titleField.push(item.label);
      });
      let setExportData = [];
      Object.keys(data).forEach((item) => {
        if (item == "query_time") {
          return;
        }
        let exportData = [];
        data[item].forEach((rowData) => {
          let singleRowData = [];
          titleKey.forEach((key) => {
            singleRowData.push(rowData[key]);
          });
          exportData.push(singleRowData);
        });
        let sheetName = "";
        if (item == "maintain_data_Ziguan") {
          sheetName = "梓官廠機台報修紀錄";
        } else if (item == "maintain_data_Qiaotou") {
          sheetName = "橋頭廠機台報修紀錄";
        }
        let exportObj = {
          sheetName: sheetName,
          title: titleField,
          data: exportData,
        };
        setExportData.push(exportObj);
      });
      vm.set_exportExcelData(setExportData);
      vm.set_exportExcelFileName(fileName);
    },
  },
  destroyed() {
    let vm = this;
    vm.clearExportExcel();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss">
.maintain-status-table-detail th,
.maintain-status-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}
.maintain-status-table-detail th {
  border-top: none !important;
}
.maintain-status-table-detail th:first-child,
.maintain-status-table-detail td:first-child {
  border-left: 1px solid;
}
.maintain-status-table-detail {
  margin-bottom: 0px;
}
.maintain-status-table-detail thead th {
  font-size: 1rem;
  color: #000000 !important;
  background-color: #cccccc !important;
}
.maintain-status-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.maintain-status-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/components/maintainLog.vue